import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { HeroImageBackground } from 'components/organisms';
import { FilterButton } from 'components/molecules';
import { ReportsService } from 'services/ReportsService';
import { ReportsContext } from '../contexts';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  specialClass: {
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% + 60px)',
    },
  },
}));

const reportsService = new ReportsService();

const Hero = props => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();
  const [categories, setCategories] = useState([]);

  const { filters, setFilters } = useContext(ReportsContext);

  useEffect(() => {
    (async () => {
      const { data } = await reportsService.categories();
      setCategories(data);
    })();
  }, []);

  const handleClick = event => {
    setFilters(prev => ({ ...prev, category: event.target.value }));
  };

  return (
    <HeroImageBackground
      // title={t('REPORTS.REPORTS')}
      backgroundImg="assets/images/reports-cover.jpg"
      backgroundIcon="Reports/Reports"
      height={210}
      mobileHeight={200}
    >
      <Grid container spacing={0}>
        {categories.map(category => (
          <Grid key={category.id} item md={4} xs={12}>
            <FilterButton
              selected={category.id === filters.category}
              className={clsx({
                [classes.specialClass]: category.title.length > 45,
              })}
              title={category.title}
              value={category.id}
              icon={category.icon}
              onClick={handleClick}
            />
          </Grid>
        ))}
      </Grid>
    </HeroImageBackground>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
